import { render, staticRenderFns } from "./DexCardsModal.vue?vue&type=template&id=6fe0d0dc&scoped=true"
import script from "./DexCardsModal.vue?vue&type=script&lang=ts"
export * from "./DexCardsModal.vue?vue&type=script&lang=ts"
import style0 from "./DexCardsModal.vue?vue&type=style&index=0&id=6fe0d0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe0d0dc",
  null
  
)

export default component.exports